import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"

class BasketNumber extends Component {
    render() {
        const {id, number} = this.props


        return (
            <td className='BasketNumber'>
                <Link to={`/baskets/${id}`}>
                    {number}
                </Link>
            </td>
        )
    }
}

BasketNumber.propTypes = {
    number: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
}

export default BasketNumber
